import React from "react";
import Page from "src/components/Page";
import AboutUs from "./About";

function Index() {
  localStorage.removeItem("@storeAuctionLot");

  return (
    <Page title="About Us | Leon Gallery">
      <AboutUs />
    </Page>
  );
}

export default Index;